import InnerBanner from "../Components/InnerBanner/InnerBanner";
import MultiContent from "../Components/MultiContent/MultiContent";

function Programs() {
    return (
        <>
            <InnerBanner
                img_url='programBanner.webp'
                heading={['Explore Our Programs:', <br/>, 'Your Path to DevOps Excellence']}
            />
            <MultiContent
                right_img
                topHeading
                heading="Explore Our Programs: Your Path to DevOps Excellence"
                description={[
                    "Welcome to the heart of Skill Bridge offerings - our diverse and enriching range of programs designed to guide you on your journey towards becoming a proficient DevOps professional. Whether you prefer the flexibility of online learning or the immersive experience of onsite training, we've got the right path for you."
                ]}
                img_url='program1.webp'
            />
            <MultiContent
                right_img
                class="coloured"
                topHeading
                heading="Online Programs - Learning at Your Pace"
                description={[
                    "Our online programs are tailored for those who value flexibility and accessibility. You can access our high-quality content from anywhere in the world, allowing you to balance your career goals with your current commitments."
                ]}
                img_url='program2.webp'
                accordion={[
                    {
                        'head': 'Comprehensive Curriculum',
                        'content': 'Dive deep into the world of DevOps with our well-structured online courses. From the fundamentals to advanced techniques, our programs cover it all.'
                    },
                    {
                        'head': 'Flexible Scheduling',
                        'content': 'Study at your own pace, fitting your coursework around your existing schedule. Our online platform is available 24/7, giving you the freedom to learn when it suits you best.'
                    },
                    {
                        'head': 'Supportive Community',
                        'content': 'Join a vibrant online community of learners, where you can engage in discussions, seek\n' +
                            'guidance, and collaborate with fellow DevOps enthusiasts.'
                    },
                    {
                        'head': 'Career Guidance',
                        'content': 'Our commitment to your success extends beyond the virtual classroom. We provide career\n' +
                            'guidance and support to help you chart your path in the DevOps industry.'
                    }
                ]}
            />
            <MultiContent
                left_img
                tag="ONSITE PROGRAM"
                topHeading
                heading="Immersive Learning"
                description={[
                    "If you thrive in a classroom setting and value hands-on experience, our onsite programs are perfect for you. Immerse yourself in the world of DevOps with our dynamic in-person courses."
                ]}
                descClass='min'
                img_url='program3.webp'
                accordion={[
                    {
                        'head': 'Interactive Classes',
                        'content': 'Our onsite classes offer an interactive learning environment, where you can engage with\n' +
                            'instructors and peers in real-time.'
                    },
                    {
                        'head': 'Hands-On Experience',
                        'content': 'Gain practical experience through workshops, projects, and simulations. Our onsite\n' +
                            'programs emphasise experiential learning.'
                    },
                    {
                        'head': 'Networking Opportunities',
                        'content': 'Build valuable connections with industry professionals and like-minded peers, opening doors\n' +
                            'to future collaborations and career opportunities.'
                    },
                    {
                        'head': 'Career Support',
                        'content': "We're here to help you transition from the classroom to the workforce. Our career support\n" +
                            "services include resume building, interview coaching, and job placement assistance."
                    }
                ]}
            />
            <MultiContent
                right_img
                class="coloured"
                topHeading
                heading="Career Paths and Support"
                description={[
                    "At Skill Bridge we don't just provide training; we pave the way for your career success. We\n" +
                    "offer a clear roadmap for career development, ensuring you're well-prepared to enter the\n" +
                    "DevOps field.\n"
                ]}
                img_url='program4.webp'
                accordion={[
                    {
                        'head': 'Entry-Level Path',
                        'content': "If you're new to DevOps, our entry-level programs provide a solid foundation. Start your\n" +
                            "journey with confidence and essential skills."
                    },
                    {
                        'head': 'Advanced Path',
                        'content': 'For experienced professionals, our advanced programs offer specialised training to take\n' +
                            'your DevOps career to the next level.'
                    },
                    {
                        'head': 'Ongoing Support',
                        'content': 'Even after completing your program, we\'re here to support your career growth. Benefit from\n' +
                            'our alumni network, job boards, and industry insights.'
                    },
                ]}
            />
            <MultiContent
                left_img
                tag="how we work"
                topHeading
                heading="Continuous Learning"
                description={[
                    "The tech world evolves rapidly. Stay updated with our ongoing learning resources and\n" +
                    "workshops to remain competitive in the field.",
                    "Skill Bridge is not just an educational institution; we are your partners in success. Join our\n" +
                    "programs, whether online or onsite, and embark on a journey towards a rewarding DevOps\n" +
                    "career. Explore our courses today and discover the endless possibilities that await you in the\n" +
                    "world of DevOps.",
                    "Your journey to DevOps excellence starts here with Skill Bridge."
                ]}
                img_url='program5.webp'
            />
        </>
    )
}

export default Programs